/** "Is Tuesday really the cheapest day to fly? What 4,032 fares show": metadata (the article is in ../bodies/cheapest-day-to-fly.js). */
export default {
  slug: 'cheapest-day-to-fly',
  category: 'Research',
  label: 'Research · November 2026',
  title: 'Is Tuesday really the cheapest day to fly? What 4,032 fares show',
  seoTitle: 'Cheapest Day to Fly: Is It Tuesday? (2026 Data)',
  description: 'We compared 4,032 one-way fares on 24 routes. Tuesday and Wednesday flights averaged 7.5% below their week’s average fare; Sunday ran 13.4% above.',
  dek: 'We priced every departure date for 24 weeks on 24 routes to find the cheapest day of the week to fly. Tuesday and Wednesday won, Sunday lost, and how much it matters depends on the route.',
  author: 'Stephanie Ludwig',
  published: '2026-11-03',
  updated: '2026-11-03',
  faqs: [
    {
      q: 'What is the cheapest day of the week to fly?',
      a: 'In our data, Tuesday and Wednesday tied, each averaging 7.5% below the average fare of its week on the same route. One of the two was the cheapest day in 54% of the 576 route-weeks we priced.',
    },
    {
      q: 'What is the most expensive day to fly?',
      a: 'Sunday. Sunday departures averaged 13.4% above their week’s average fare, were the most expensive day on 14 of 24 routes, and were the cheapest day of the week in only 4.4% of route-weeks.',
    },
    {
      q: 'Is it cheaper to book flights on a Tuesday?',
      a: 'Our data can’t test that, because every fare was collected on the same day. Google’s October 2026 analysis found the day you book makes little difference: booking on a Wednesday saved only about 1.4% compared with Sunday.',
    },
    {
      q: 'How much can you save by flying on a Tuesday instead of a Sunday?',
      a: 'Across all our routes, the average cheapest one-way fare was $171 on a Tuesday and $196 on a Sunday, a $25 difference per traveler per flight. On some domestic routes, such as Denver to Dallas, the gap was far bigger.',
    },
    {
      q: 'Does the cheapest day to fly apply to international flights?',
      a: 'Much less. On our eight international routes, Tuesday averaged 5.8% below the week and Sunday only 3.0% above, compared with 18.6% above for Sunday on domestic routes.',
    },
    {
      q: 'Is Saturday a cheap day to fly?',
      a: 'On domestic routes, somewhat: Saturday averaged 2.4% below its week and was the cheapest day in 12.8% of route-weeks overall. On international routes it averaged 4.7% above the week.',
    },
  ],
  related: [
    'when-to-book-flights-fare-data',
    'basic-economy-real-cost',
    'do-cheap-flight-sites-have-cheaper-fares',
  ],
};
